import { ref } from "vue";

const STORAGE_KEY = "se.expert.walletPreview.collapsed";

function readInitial(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

// Module-level ref so every mounted preview (desktop sidebar + mobile menu)
// shares and persists the same collapsed/expanded state.
const collapsed = ref<boolean>(readInitial());

export function useWalletPreviewCollapsed() {
  function setCollapsed(value: boolean) {
    collapsed.value = value;
    try {
      localStorage.setItem(STORAGE_KEY, value ? "1" : "0");
    } catch {
      // Ignore persistence errors (e.g. storage disabled).
    }
  }

  function toggle() {
    setCollapsed(!collapsed.value);
  }

  return { collapsed, setCollapsed, toggle };
}
